import { __ } from '../utils';
import { TextField, type SxProps } from '@presov.sk/presov-ui-react';
import SearchIcon from '@mui/icons-material/Search';
import React from 'react';

export type SearchBarProps = {
  debounce?: number;
};

type Props = SearchBarProps & {
  searchValue?: string;
  setSearchValue?: (value: string) => void;
  sx?: SxProps;
};

const SearchBar: React.FC<Props> = ({
  searchValue,
  setSearchValue,
  sx,
  debounce = 0,
}) => {
  const [localValue, setLocalValue] = React.useState('');
  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setLocalValue(value);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setSearchValue(value);
    }, debounce);
  };

  React.useEffect(() => {
    setLocalValue(searchValue);
  }, [searchValue]);

  return (
    <TextField
      className='screen-only'
      sx={sx}
      type={'search'}
      placeholder={__('Hľadať...')}
      variant='outlined'
      value={localValue}
      onChange={handleSearchChange}
      slotProps={{
        root: {
          sx: {
            width: {
              xs: '100%',
              md: 240,
            },
            minWidth: 200,
            maxWidth: '100%',
            height: 32,
            minHeight: 32,
            display: 'flex',
          },
        },
        input: {
          sx: {
            minWidth: '100%',
            background: (theme) => theme.palette.grey[100],
            height: 32,
            minHeight: 32,
            px: 1,
            py: 0,
            '> input': {
              pr: 0,
              pl: 0.5,
            },
          },
          startAdornment: (
            <SearchIcon sx={{ p: 0, fontSize: 18, color: 'text.secondary' }} />
          ),
        },
      }}
    />
  );
};

export default SearchBar;
